<template>
  <div class="web-footer">
    <div class="link">
      <div class="icon">
        <el-popover
          placement="top"
          trigger="hover">
         <!-- US202402025 zhangwenxing 微信二维码更换 -->
          <img src="static/img/footer/link-weixin-US202402025.png" class="icon-size-weixin-tip"/>
          <img src="static/img/footer/weixin.png"  slot="reference" class="icon-size-weixin"/>
          <!--onmouseover="this.src='static/img/footer/weixin2.png'"
               onmouseout="this.src='static/img/footer/weixin.png'"-->
        </el-popover>
        <!--US202308055移除网站下方“领英企业服务”按钮及跳转链接-->
        <!--<img src="static/img/footer/lingying.png"
             @click="toLink('https://www.linkedin.cn/incareer/company/1016')"
             class="icon-size" />-->
        <!--onmouseover="this.src='static/img/footer/lingying2.png'"
             onmouseout="this.src='static/img/footer/lingying.png'"-->
       <!--US202402025 zhangwenxing start新增boss图标-->
        <img src="static/img/footer/boss.png"
             @click="toLink('https://www.zhipin.com/gongsi/28fb96c8fb18c8480nd809i5FQ~~.html?ka=search_rcmd_company_28fb96c8fb18c8480nd809i5FQ~~_custompage')"
             class="icon-size"/>
        <!--US202402025 zhangwenxing end新增boss图标-->

        <img src="static/img/footer/liepin.png"
             @click="toLink('https://www.liepin.com/company/167530?suggestId=0783d0bb4634f44547175c3739d29c5a')"
             class="icon-size"/>
<!--onmouseover="this.src='static/img/footer/liepin2.png'"
             onmouseout="this.src='static/img/footer/liepin.png'"-->


       <!-- <img src="static/img/footer/boss.png" onmouseover="this.src='static/img/footer/boss2.png'"
             onmouseout="this.src='static/img/footer/boss.png'"
             @click="toLink('https://www.zhipin.com/gongsi/28fb96c8fb18c8480nd809i5FQ~~.html?ka=company-intro')"
             class="icon-size"/>-->

        <img src="static/img/footer/dingxiangyuan.png"
             @click="toLink('https://www.jobmd.cn/company/787583.htm?from=searchent_1')"
             class="icon-size"/>
        <!--onmouseover="this.src='static/img/footer/dingxiangyuan2.png'"
             onmouseout="this.src='static/img/footer/dingxiangyuan.png'"-->

        <!--<img src="static/img/footer/104yinhang.png" onmouseover="this.src='static/img/footer/104yinhang2.png'"
             onmouseout="this.src='static/img/footer/104yinhang.png'"
             @click="toLink('https://www.104.com.tw/company/59lvswo?jobsource=cs_2018indexpoc')"
             class="icon-size"/>-->

        <img src="static/img/footer/bilibili.png"
             @click="toLink('https://space.bilibili.com/516580323?spm_id_from=333.337.search-card.all.click')"
             class="icon-size"/>
        <!--onmouseover="this.src='static/img/footer/bilibili2.png'"
             onmouseout="this.src='static/img/footer/bilibili.png'"-->
      </div>
    </div>
    <div class="cooperation">
      <div>
        <span @click="toLink('https://www.gehealthcare.cn/')">GE医疗中国官网</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="toLink('https://jobs.gecareers.com/healthcare/global/en/')">全球招聘网站</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="toLink('https://www.gehealthcare.com/zh-cn/china-news')">新闻资讯</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="toLink('https://www.gehealthcare.com/zh-cn/about-gehc-china/company-vision#pcb-sc')">企业社会责任</span>
       <!-- <el-divider direction="vertical"></el-divider>
        <a href="mailto:Career.GEHC@ge.com" >联系我们</a>
-->
      </div>
      <div class="mail">联系方式 : Career.GEHC@ge.com</div>
    </div>

    <div class="keep-record">
      <div @click="toLink('http://www.beian.gov.cn')">
        <img src="static/img/wangan.png" class="wangan"/>
        <span>
        沪公网安备  31011502016102号
       </span>
      </div>
      <span @click="toLink('https://beian.miit.gov.cn')">沪ICP备11019805号-10</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebFooter',
  data () {
    return {
    }
  },
  methods:{
    toLink(link){
      window.open(link,'_blank');
    }
  }
}
</script>
<style>
 .cooperation .el-divider--vertical{
    width: 2px;
  }
</style>
<style scoped>
  .icon-size{

  }
  * {
    margin: 0;
    padding: 0;
  }
  .web-footer{
    width: 100%;
    min-height: 300px;
    color: #5E5E5E;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .web-footer .link{
    width: 100%;
    min-height: 88px;
    background-color: #373737;
    display: flex;
    justify-content: center;
    align-items: center;


  }
  .web-footer .link .icon{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

  }


  .web-footer .link .icon > *{
    margin: 10px 70px ;
    cursor:pointer;
/*    padding: 10px 50px ;*/

  }
  .web-footer .link .icon > * :hover{
    transform: scale(1.3)
  }
  .web-footer .link .icon-size:nth-child(2):hover{
    transform: scale(1.3)
  }
  .web-footer .link .icon-size:nth-child(2):hover{
    transform: scale(1.3)
  }
  .web-footer .link .icon-size:nth-child(3):hover{
    transform: scale(1.3)
  }
  .web-footer .link .icon-size:nth-child(4):hover{
    transform: scale(1.3)
  }
  .web-footer .link .icon-size:nth-child(5):hover{
    transform: scale(1.3)
  }
  .web-footer .link .icon-size:nth-child(6):hover{
    transform: scale(1.3)
  }
  .web-footer .link .icon-size:nth-child(7):hover{
    transform: scale(1.3)
  }
  .web-footer .link .icon-size:nth-child(2){
    width: 39px;
    height: 39px;
  }
  .web-footer .link .icon-size:nth-child(3){
    width: 40px;
    height: 40px;
  }
  .web-footer .link .icon-size:nth-child(4){
    width: 39px;
    height: 39px;
  }
  .web-footer .link .icon-size:nth-child(5){
    width: 74px;
    height: 33px;
  }
/*  .web-footer .link .icon-size:nth-child(6){
    width: 74px;
    height: 33px;
  }*/

  .web-footer .link .icon-size-weixin{
    width: 46px;
    height: 38px;
  }
  .web-footer .link .icon-size-weixin-tip{
    width: 150px;
    height: 150px;
  }
  .web-footer .cooperation{
    width: 100%;
    min-height: 106px;
    background-color:#373737;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 78px 0 0 0;
    margin: 13px 0 0 0;
    color: #ffffff;
    font-size: 16px;
  }
  .web-footer .cooperation > div{
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 22px;
  }
  .mail{
    margin-left: 77.7vw !important;
    /*margin-right: -1200px !important;*/
  /*  margin-right: -82.5vw !important;*/
    font-size:1vw !important;
    margin-top:2.08vw !important;
  }
  .web-footer .cooperation > div > *{
    margin:0 18px;
    font-size: 26px;
    cursor:pointer;
  }
  .web-footer .cooperation > div > :hover{
    transform: scale(1.2)
  }
  .web-footer .cooperation > div >a{
    text-decoration:none;
    color:#ffffff ;
  }
  .web-footer .cooperation > div:nth-child(2){
    margin: 32px 0 0 0 ;
  }
  .web-footer .olympics-icon{
    width: 178px;
    height: 85px;
    margin-bottom: 19px;
  }
  .web-footer .keep-record{
    width: 100%;
    min-height: 62px;
    background-color: #DBDBDB;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    text-align: center;
    color: #333333;
  }
  .web-footer .keep-record > *:nth-child(1){
    font-weight: bold;
    margin: 0 19px 0 6px;
    display: flex;
    cursor:pointer;
  }
  .web-footer .keep-record > *:nth-child(2){
    /*margin: 4px 0 0 0;*/
    cursor:pointer;
  }
 /* .web-footer .cooperation> *:first-child > *:hover{
    color: #6400a0;
    text-decoration: underline;
  }*/
  .web-footer .wangan{
    width: 18px;
    height: 20px;
    margin:-2px 6px 0 0;
  }
  @media only screen and (min-width: 1215px){
    /*大分辨率*/
    .web-footer .olympics-icon{
      margin-left: 1025px;
    }
  }
  @media only screen and (max-width: 1215px){
    /*小分辨率*/
    .web-footer .keep-record{
      flex-direction: column;
    }
    .web-footer .olympics-icon{
      margin-top: 20px;
    }
  }
  @media only screen and (max-width: 868px){
    .web-footer .link .icon > *{
      margin: 15px 30px ;
    }
  }
  @media only screen and (max-width: 760px){
    /*小分辨率*/
    .web-footer .el-divider{
      display: none;
    }
    .web-footer .cooperation > *:first-child{
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
    .web-footer .cooperation > *:first-child > *{
      margin: 0 12px 10px;
    }
    .web-footer .cooperation{
      font-size: 14px;
    }
    .web-footer .link .icon-size:first-child {
      width: 28px;
      height: 28px;
    }
    .web-footer .link .icon-size:nth-child(2){
      width: 35px;
      height: 29px;
    }
    .web-footer .link .icon-size:nth-child(3){
      width: 28px;
      height: 33px;
    }
    .web-footer .link .icon-size:nth-child(4){
      width: 28px;
      height: 28px;
    }
    .web-footer .link .icon-size:nth-child(5){
      width: 32px;
      height: 27px;
    }
    .web-footer .cooperation > div{
      font-size: 16px;
    }
    .web-footer .cooperation > div > *{
      font-size: 19px;
    }
    .web-footer .keep-record{
      font-size: 13px;
    }
    .web-footer .olympics-icon{
      width: 128px;
      height: 61px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/web/footer.vue